// import axios from "axios";
// 用户动态
// 参数说明 this  操作类型(0全部，1登录，2新增，3编辑，4详情，5删除)  操作模块  操作内容

export async function getUserIP(this1, logType, operModule, operContent) {
  const res = await this1.$axios
    .post(
      "/apis/hmcsDigitCommon/system/set/operateLog/add?SSOID=" +
        $cookies.get("SSOID"),
      // 直接传对象，不要用 URLSearchParams
      {
        loginUserName: $cookies.get("username"),
        tenantId: "",
        operateType: logType,
        moduleId: operModule,
        operateContent: operContent,
      },
      // 加请求头（axios默认就是json，不加也能行，加上更保险）
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((res) => {
      if (res.data.success) {
        console.log("记录了");
      }
    })
    .catch((err) => {
      console.log(err);
    });
}
